import React, { SVGProps } from "react";

export default function SupGripX(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.36842 7.89478C5.36842 8.82495 4.61437 9.57899 3.68421 9.57899C2.75405 9.57899 2 8.82495 2 7.89478C2 6.96462 2.75405 6.21057 3.68421 6.21057C4.61437 6.21057 5.36842 6.96462 5.36842 7.89478ZM4.52632 7.89478C4.52632 8.35986 4.14929 8.73689 3.68421 8.73689C3.21913 8.73689 2.84211 8.35986 2.84211 7.89478C2.84211 7.4297 3.21913 7.05268 3.68421 7.05268C4.14929 7.05268 4.52632 7.4297 4.52632 7.89478Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.57895 7.89478C9.57895 8.82495 8.8249 9.57899 7.89474 9.57899C6.96457 9.57899 6.21053 8.82495 6.21053 7.89478C6.21053 6.96462 6.96457 6.21057 7.89474 6.21057C8.8249 6.21057 9.57895 6.96462 9.57895 7.89478ZM8.73684 7.89478C8.73684 8.35986 8.35982 8.73689 7.89474 8.73689C7.42966 8.73689 7.05263 8.35986 7.05263 7.89478C7.05263 7.4297 7.42966 7.05268 7.89474 7.05268C8.35982 7.05268 8.73684 7.4297 8.73684 7.89478Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1053 9.57899C13.0354 9.57899 13.7895 8.82495 13.7895 7.89478C13.7895 6.96462 13.0354 6.21057 12.1053 6.21057C11.1751 6.21057 10.4211 6.96462 10.4211 7.89478C10.4211 8.82495 11.1751 9.57899 12.1053 9.57899ZM12.1053 8.73689C12.5703 8.73689 12.9474 8.35986 12.9474 7.89478C12.9474 7.4297 12.5703 7.05268 12.1053 7.05268C11.6402 7.05268 11.2632 7.4297 11.2632 7.89478C11.2632 8.35986 11.6402 8.73689 12.1053 8.73689Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 7.89478C18 8.82495 17.246 9.57899 16.3158 9.57899C15.3856 9.57899 14.6316 8.82495 14.6316 7.89478C14.6316 6.96462 15.3856 6.21057 16.3158 6.21057C17.246 6.21057 18 6.96462 18 7.89478ZM17.1579 7.89478C17.1579 8.35986 16.7809 8.73689 16.3158 8.73689C15.8507 8.73689 15.4737 8.35986 15.4737 7.89478C15.4737 7.4297 15.8507 7.05268 16.3158 7.05268C16.7809 7.05268 17.1579 7.4297 17.1579 7.89478Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.68421 13.7895C4.61437 13.7895 5.36842 13.0355 5.36842 12.1053C5.36842 11.1751 4.61437 10.4211 3.68421 10.4211C2.75405 10.4211 2 11.1751 2 12.1053C2 13.0355 2.75405 13.7895 3.68421 13.7895ZM3.68421 12.9474C4.14929 12.9474 4.52632 12.5704 4.52632 12.1053C4.52632 11.6402 4.14929 11.2632 3.68421 11.2632C3.21913 11.2632 2.84211 11.6402 2.84211 12.1053C2.84211 12.5704 3.21913 12.9474 3.68421 12.9474Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.57895 12.1053C9.57895 13.0355 8.8249 13.7895 7.89474 13.7895C6.96457 13.7895 6.21053 13.0355 6.21053 12.1053C6.21053 11.1751 6.96457 10.4211 7.89474 10.4211C8.8249 10.4211 9.57895 11.1751 9.57895 12.1053ZM8.73684 12.1053C8.73684 12.5704 8.35982 12.9474 7.89474 12.9474C7.42966 12.9474 7.05263 12.5704 7.05263 12.1053C7.05263 11.6402 7.42966 11.2632 7.89474 11.2632C8.35982 11.2632 8.73684 11.6402 8.73684 12.1053Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1053 13.7895C13.0354 13.7895 13.7895 13.0355 13.7895 12.1053C13.7895 11.1751 13.0354 10.4211 12.1053 10.4211C11.1751 10.4211 10.4211 11.1751 10.4211 12.1053C10.4211 13.0355 11.1751 13.7895 12.1053 13.7895ZM12.1053 12.9474C12.5703 12.9474 12.9474 12.5704 12.9474 12.1053C12.9474 11.6402 12.5703 11.2632 12.1053 11.2632C11.6402 11.2632 11.2632 11.6402 11.2632 12.1053C11.2632 12.5704 11.6402 12.9474 12.1053 12.9474Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 12.1053C18 13.0355 17.246 13.7895 16.3158 13.7895C15.3856 13.7895 14.6316 13.0355 14.6316 12.1053C14.6316 11.1751 15.3856 10.4211 16.3158 10.4211C17.246 10.4211 18 11.1751 18 12.1053ZM17.1579 12.1053C17.1579 12.5704 16.7809 12.9474 16.3158 12.9474C15.8507 12.9474 15.4737 12.5704 15.4737 12.1053C15.4737 11.6402 15.8507 11.2632 16.3158 11.2632C16.7809 11.2632 17.1579 11.6402 17.1579 12.1053Z"
        fill="currentColor"
      />
    </svg>
  );
}
